import i18n from '@/i18n';

export class ShipmentRelatedInvoiceReference {
  invoiceId: number;
  type: 'CARRIER_INVOICE' | 'CLIENT_INVOICE';
  status:
    | 'DRAFT'
    | 'NEW'
    | 'INVOICE_DISCREPANCY'
    | 'HOLD'
    | 'READY_FOR_BILLING'
    | 'BILLED'
    | 'COMPLETE'
    | 'VOID';
  invoiceNumber: string;

  constructor(opts: ShipmentRelatedInvoiceReference) {
    this.invoiceId = opts.invoiceId;
    this.type = opts.type;
    this.status = opts.status;
    this.invoiceNumber = opts.invoiceNumber;
  }

  isVoid(): boolean {
    return this.status === 'VOID';
  }

  getDescription(): string {
    if (this.type === 'CARRIER_INVOICE') {
      return i18n.global.t('shipments.financials.carrierInvoiceNumParam', {
        param: this.invoiceNumber,
      });
    } else if (this.type === 'CLIENT_INVOICE') {
      return i18n.global.t('shipments.financials.clientInvoiceNumParam', {
        param: this.invoiceNumber,
      });
    }

    return `#${this.invoiceNumber}`;
  }
}
